import { useWindowSize } from 'react-use';

/**
 * @description Determines the current browser window width.
 * isMobileView (for browser widths < 1024px).
 * isDesktopView (for browser widths >= 1024px).
 * @returns Object
 */
export default () => {
  const { width } = useWindowSize();

  return {
    isMobileView: width > 0 && width < 1280,
    isDesktopView: width >= 1280,
    isWindowWidthSet: width !== 0,
  };
};
